/**
 * 指定した区切り文字列で分割された文字列から、最初のグループのメールアドレスを抽出する
 * @param input 処理対象の文字列
 * @param separator 区切り文字列
 * @returns 区切り文字列より前の部分に含まれるメールアドレスの配列
 */
export const extractEmailsBeforeSeparator = (input: string, separator: string): string[] => {
  const firstPart = input.split(separator)[0];
  return firstPart.split('\n').filter((line) => line.includes('@'));
};

/**
 * 区切り文字列より前の部分のメールアドレス群を新しい配列で置き換える
 * @param input 処理対象の文字列
 * @param newEmails 新しいメールアドレスの配列
 * @returns 置き換え後の文字列
 */
export const replaceEmailsBeforeSeparator = (input: string, newEmails: string[], separator: string): string => {
  const parts = input.split(separator);
  const newEmailsStr = newEmails.join('\n');

  if (parts.length === 1) {
    return newEmailsStr;
  }

  return newEmailsStr + separator + parts[1];
};
